// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__IsbMx","errorLogs":"styles_errorLogs__3434E"};